let toastContainer = null;

function getToastContainer() {
  if (!toastContainer || !document.body.contains(toastContainer)) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'toast-notification-container';
    toastContainer.style.cssText = `
      position: fixed;
      top: 24px;
      right: 24px;
      z-index: 999999;
      display: flex;
      flex-direction: column;
      gap: 10px;
      pointer-events: none;
      max-width: min(420px, calc(100vw - 32px));
    `;
    document.body.appendChild(toastContainer);
  }
  return toastContainer;
}

export function showToast(message, type = 'info') {
  if (typeof document === 'undefined') return;
  const container = getToastContainer();
  const toast = document.createElement('div');
  toast.className = `toast-box toast-box--${type}`;

  const iconMap = {
    success: '✓',
    error: '✕',
    warning: '⚠️',
    info: 'ℹ️'
  };
  const icon = iconMap[type] || 'ℹ️';

  const bgMap = {
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#2563eb'
  };
  const bg = bgMap[type] || '#2563eb';

  toast.style.cssText = `
    pointer-events: auto;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 18px;
    border-radius: 12px;
    color: white;
    font-size: 0.9rem;
    font-weight: 600;
    line-height: 1.4;
    background: ${bg};
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.25), 0 8px 10px -6px rgba(0, 0, 0, 0.2);
    animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    cursor: pointer;
    word-break: break-word;
    border: 1px solid rgba(255, 255, 255, 0.2);
    transition: transform 0.15s ease;
  `;

  const iconSpan = document.createElement('span');
  iconSpan.style.cssText = 'font-size: 1.1rem; flex-shrink: 0;';
  iconSpan.textContent = icon;

  const textSpan = document.createElement('span');
  textSpan.style.cssText = 'flex: 1;';
  textSpan.textContent = message;

  toast.appendChild(iconSpan);
  toast.appendChild(textSpan);

  const removeToast = () => {
    toast.style.animation = 'slideOut 0.25s ease forwards';
    setTimeout(() => {
      if (container.contains(toast)) {
        container.removeChild(toast);
      }
    }, 250);
  };

  toast.onclick = removeToast;
  container.appendChild(toast);

  setTimeout(removeToast, 3500);
}

const toastMixin = {
  methods: {
    showToast,
    success(message) {
      showToast(message, 'success');
    },
    error(message) {
      showToast(message, 'error');
    },
    info(message) {
      showToast(message, 'info');
    },
    warning(message) {
      showToast(message, 'warning');
    }
  }
};

export default toastMixin;
